<template>
  <nav
    class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-minimize">
          <button
            id="minimizeSidebar"
            class="btn btn-sidebar-toggle"
          >
            <i
              class="material-icons text_align-center visible-on-sidebar-regular"
              >more_vert</i
            >
            <i
              class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
              >view_list</i
            >
          </button>
        </div>
        <a class="navbar-brand" href="/"></a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <span style="font-size: 24px; font-weight: 700; color: #1e293b; letter-spacing: -0.5px; margin-left: 15px;">NIC - UFSM</span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
    
};
</script>